<template>
  <div class="profile-container">
    <avatar-icon class="icon" :user="user" />

    <div class="name">
      <div class="paragraph-content">
        {{ user?.displayName }}
      </div>
      <div class="subtext-content">
        {{ user?.email }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { watch } from 'vue';
import { useAuthentication, AvatarIcon } from 'ihunter-pathfinder-components';

const { user } = useAuthentication();

watch(user, async () => {
    console.log(`User changed`, user.value);
});
</script>

<style lang="scss" scoped>
@use 'ihunter-pathfinder/styles' as Pathfinder;
@use '../styles/Accounts' as Accounts;

@include Accounts.Default;

.profile-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: Pathfinder.$space-300;

    .icon {
        width: Pathfinder.$avatar-default;
        height: Pathfinder.$avatar-default;
    }

    .name {
      display: flex;
      flex-direction: column;
      gap: Pathfinder.$space-25;
      padding-left: Pathfinder.$space-200;
    }
}
</style>
